<template>
  <div id="app" class="app-container">
    <div v-if="loading" class="loader-container">
      <Loader></Loader>
    </div>
    <main v-if="!logged" class="login-card">
      <div class="login-card__logo">
      </div>
      <LoginForm class="login-form"
        @login="loginSuccess"
      ></LoginForm>
    </main>
    <GetSignCard
            v-else-if="getImageSignWidgetOpened"
            class="get-sign-card"
            @save="saveSignImage"
            @close="closeSignImage"
    ></GetSignCard>
    <template v-else>
      <div class="login-card" v-if="activeStep === 1">
        <div class="text-center">
          <button type="button" class="btn btn-primary" @click="startWizard">
            Acquisisci un documento
          </button>
        </div>
      </div>
      <div v-else-if="activeStep === 2">
        <h1>Dati scontrino</h1>

        <form @submit.prevent="sendScontrino">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="scontrinoData">Data</label>
                  <input type="date" class="form-control" id="scontrinoData" v-model="scontrino.data">
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="scontrinoImporto">Importo</label>
                  <input type="number" step=".01" min="0" class="form-control" id="scontrinoImporto" v-model="scontrino.importo">
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="scontrinoImponibile">Imponibile</label>
                  <input type="number" step=".01" min="0" class="form-control" id="scontrinoImponibile" v-model="scontrino.imponibile">
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="scontrinoIva">Iva</label>
                  <input type="number" step=".01" min="0" class="form-control" id="scontrinoIva" v-model="scontrino.iva">
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="scontrinoId">Id</label>
                  <input type="text" class="form-control" id="scontrinoId" v-model="scontrino.id">
                </div>
              </div>

              <div class="col-12 text-right">
                <button type="submit" class="btn btn-success">
                  Avanti
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div v-else-if="activeStep === 3">
          <SelectDocumentTypeForm :documents="documents" @selected="selectDocumentType"></SelectDocumentTypeForm>
      </div>
      <div class="full-card" style="overflow: hidden; position: relative;" v-else-if="activeStep === 4">
        <div v-if="frontImage"> <!--  :style="imageBoxStyle" -->
          <img
              style="display: block; max-width: 100vw; max-height: 100vh; position: absolute; top: 50%;left: 50%;transform: translate(-50%, -50%)"
              :src="frontImage"
          >
          <!-- top: 0; bottom: 0; left: 0; right: 0; -->
          <button type="button" class="btn btn-danger" style="position: absolute;top:0;left:0;" @click.prevent="removeFrontImage">Rimuovi</button>
          <button type="button" class="btn btn-success" style="position: absolute;top:0;right:0;" @click.prevent="elaborateImage">Conferma immagine<br>e elabora</button>
        </div>
        <TakeRTCImage v-else
                      style="display: block; max-width: 100vw; max-height: 100vh; position: absolute; top: 0; bottom: 0; left: 0; right: 0;"
                      @setImage="setFrontImage" :maskRatio="documentType.ratio" key="front"></TakeRTCImage>
      </div>
      <div class="page-step" v-else-if="activeStep === 5">
        <h5 class="title" v-if="elaborateImageResult === null">Elaborazione in corso</h5>

        <template v-if="elaborateImageResult === true">
          <div class="container-fluid">
          <form @submit.prevent="checkData">
              <fieldset class="form-group">
                  <legend>Cliente</legend>
                  <div class="row">
                      <div class="col-12 col-sm-6">
                          <div class="form-group" :class="{
                                'ocr-error': documentFieldsHints.cognome !== undefined && documentFieldsHints.cognome === 0,
                                'ocr-ok':    documentFieldsHints.cognome !== undefined && documentFieldsHints.cognome === 1,
                                'ocr-warn':  documentFieldsHints.cognome !== undefined && documentFieldsHints.cognome === 2,
                          }">
                              <label for="cognome">* Cognome</label>
                              <input type="text" id="cognome" required class="form-control" v-model="documentFields.cognome" @input.prevent="resetHint('cognome')">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group" :class="{
                                'ocr-error': documentFieldsHints.nome !== undefined && documentFieldsHints.nome === 0,
                                'ocr-ok':    documentFieldsHints.nome !== undefined && documentFieldsHints.nome === 1,
                                'ocr-warn':  documentFieldsHints.nome !== undefined && documentFieldsHints.nome === 2,
                          }">
                              <label for="nome">* Nome</label>
                              <input type="text" id="nome" required class="form-control" v-model="documentFields.nome" @input.prevent="resetHint('nome')">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group" :class="{
                                'ocr-error': documentFieldsHints.sesso !== undefined && documentFieldsHints.sesso === 0,
                                'ocr-ok':    documentFieldsHints.sesso !== undefined && documentFieldsHints.sesso === 1,
                                'ocr-warn':  documentFieldsHints.sesso !== undefined && documentFieldsHints.sesso === 2,
                          }">
                              <label for="sesso">* Sesso</label>
                              <input type="text" id="sesso" required class="form-control" v-model="documentFields.sesso" @input.prevent="resetHint('sesso')">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="nascita_comune">* Comune o Stato estero di nascita</label>
                              <input type="text" id="nascita_comune" required class="form-control" v-model="documentFields.nascita_comune">
                          </div>
                      </div>
                      <!--div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="nascita_provincia">Provincia di nascita</label>
                              <input type="text" id="nascita_provincia" class="form-control" v-model="documentFields.nascita_provincia">
                          </div>
                      </div-->
                      <div class="col-12 col-sm-6">
                          <div class="form-group" :class="{
                                'ocr-error': documentFieldsHints.nascita_data !== undefined && documentFieldsHints.nascita_data === 0,
                                'ocr-ok':    documentFieldsHints.nascita_data !== undefined && documentFieldsHints.nascita_data === 1,
                                'ocr-warn':  documentFieldsHints.nascita_data !== undefined && documentFieldsHints.nascita_data === 2,
                          }">
                              <label for="nascita_data">* Data di nascita</label>
                              <input type="date" id="nascita_data" required class="form-control" v-model="documentFields.nascita_data" @input.prevent="resetHint('nascita_data')">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="codice_fiscale">Codice fiscale</label>
                              <input type="text" id="codice_fiscale" class="form-control" v-model="documentFields.codice_fiscale">
                          </div>
                      </div>
                      <!--div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="partita_iva">Partita Iva</label>
                              <input type="text" id="partita_iva" class="form-control" v-model="documentFields.partita_iva">
                          </div>
                      </div-->
                  </div>
              </fieldset>

              <fieldset class="form-group">
                  <legend>Dati del documento</legend>

                  <div class="row">
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="documento_tipo">* Tipo di documento</label>
                              <input type="text" id="documento_tipo" required class="form-control" v-model="documentFields.documento_tipo">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group" :class="{
                                'ocr-error': documentFieldsHints.documento_numero !== undefined && documentFieldsHints.documento_numero === 0,
                                'ocr-ok':    documentFieldsHints.documento_numero !== undefined && documentFieldsHints.documento_numero === 1,
                                'ocr-warn':  documentFieldsHints.documento_numero !== undefined && documentFieldsHints.documento_numero === 2,
                          }">
                              <label for="documento_numero">* Numero di documento</label>
                              <input type="text" id="documento_numero" required class="form-control" v-model="documentFields.documento_numero" @input.prevent="resetHint('documento_numero')">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="documento_data_rilascio">Data di rilascio del documento</label>
                              <input type="date" id="documento_data_rilascio" class="form-control" v-model="documentFields.documento_data_rilascio">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group" :class="{
                                'ocr-error': documentFieldsHints.documento_autorita_luogo_rilascio !== undefined && documentFieldsHints.documento_autorita_luogo_rilascio === 0,
                                'ocr-ok':    documentFieldsHints.documento_autorita_luogo_rilascio !== undefined && documentFieldsHints.documento_autorita_luogo_rilascio === 1,
                                'ocr-warn':  documentFieldsHints.documento_autorita_luogo_rilascio !== undefined && documentFieldsHints.documento_autorita_luogo_rilascio === 2,
                          }">
                              <label for="documento_autorita_luogo_rilascio">* Autorità e luogo di rilascio del documento</label>
                              <input type="text" id="documento_autorita_luogo_rilascio" required class="form-control" v-model="documentFields.documento_autorita_luogo_rilascio" @input.prevent="resetHint('documento_autorita_luogo_rilascio')">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group" :class="{
                                'ocr-error': documentFieldsHints.documento_scadenza !== undefined && documentFieldsHints.documento_scadenza === 0,
                                'ocr-ok':    documentFieldsHints.documento_scadenza !== undefined && documentFieldsHints.documento_scadenza === 1,
                                'ocr-warn':  documentFieldsHints.documento_scadenza !== undefined && documentFieldsHints.documento_scadenza === 2,
                          }">
                              <label for="documento_scadenza">* Scadenza del documento</label>
                              <input type="date" id="documento_scadenza" required class="form-control" v-model="documentFields.documento_scadenza" @input.prevent="resetHint('documento_scadenza')">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group" :class="{
                                'ocr-error': documentFieldsHints.nazionalita !== undefined && documentFieldsHints.nazionalita === 0,
                                'ocr-ok':    documentFieldsHints.nazionalita !== undefined && documentFieldsHints.nazionalita === 1,
                                'ocr-warn':  documentFieldsHints.nazionalita !== undefined && documentFieldsHints.nazionalita === 2,
                          }">
                              <label for="nazionalita">* Nazionalità</label>
                              <input type="text" id="nazionalita" required class="form-control" v-model="documentFields.nazionalita" @input.prevent="resetHint('nazionalita')">
                          </div>
                      </div>
                  </div>
              </fieldset>

              <fieldset class="form-group">
                  <legend>Residenza</legend>

                  <div class="row">
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="residenza_stato">* Stato di residenza</label>
                              <input type="text" id="residenza_stato" required class="form-control" v-model="documentFields.residenza_stato">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="residenza_comune">Comune di residenza</label>
                              <input type="text" id="residenza_comune" class="form-control" v-model="documentFields.residenza_comune">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="residenza_indirizzo">Indirizzo di residenza</label>
                              <input type="text" id="residenza_indirizzo" class="form-control" v-model="documentFields.residenza_indirizzo">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="residenza_provincia">Provincia di residenza</label>
                              <input type="text" id="residenza_provincia" class="form-control" v-model="documentFields.residenza_provincia">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="residenza_cap">Cap di residenza</label>
                              <input type="text" id="residenza_cap" class="form-control" v-model="documentFields.residenza_cap">
                          </div>
                      </div>
                      <!--div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="residenza_cab_comune">Cab del comune di residenza</label>
                              <input type="text" id="residenza_cab_comune" class="form-control" v-model="documentFields.residenza_cab_comune">
                          </div>
                      </div-->
                  </div>
              </fieldset>

              <fieldset class="form-group">
                  <legend>Beneficiario</legend>

                  <div class="row">
                      <div class="col-12 col-sm-6">
                          <div class="form-check">
                              <input type="checkbox" id="beneficiario" class="form-check-input" v-model="documentFields.beneficiario">
                              <label for="beneficiario">Il beneficiario è il cliente stesso</label>
                          </div>
                      </div>
                  </div>
                  <div class="row" v-if="!documentFields.beneficiario">
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="beneficiario_ragione_sociale">* Ragione sociale</label>
                              <input type="text" id="beneficiario_ragione_sociale" required class="form-control" v-model="documentFields.ragione_sociale">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="beneficiario_cognome">* Cognome</label>
                              <input type="text" id="beneficiario_cognome" required class="form-control" v-model="documentFields.beneficiario_cognome">
                          </div>
                      </div>
                      <div class="col-12 col-sm-6">
                          <div class="form-group">
                              <label for="beneficiario_nome">* Nome</label>
                              <input type="text" id="beneficiario_nome" required class="form-control" v-model="documentFields.beneficiario_nome">
                          </div>
                      </div>
                  </div>
              </fieldset>

              <div class="row">
                  <div class="col">
                      <button type="button" class="btn btn-danger" @click.prevent="retryElaborateImage">Acquisisci nuovamente immagine</button>
                  </div>
                  <div class="col text-right">
                      <button type="submit" class="btn btn-primary">Conferma e verifica</button>
                  </div>
              </div>
          </form>
          </div>

        </template>
        <template v-else-if="elaborateImageResult === false">
          Errore nell'elaborazione
          <button type="button" class="btn btn-primary" @click.prevent="retryElaborateImage">Riprova</button>
        </template>
      </div>
      <div class="page-step" v-else-if="activeStep === 6">
          <template v-if="checkStatus === 'ko'">
              <h1>Verifica dati non superata</h1>

              <ul>
                  <li v-for="(check, checkId) in checks" :key="checkId">
                      <strong>{{checkId}}</strong>: {{ check }}
                  </li>
              </ul>

              <button type="button" class="btn btn-danger" @click.prevent="reset">Chiudi pratica</button>
          </template>
          <template v-else>
              <div v-html="textToSign"></div>

              <div v-if="signImage">
                  <img :src="signImage" style="max-height: 200px; padding: 30px">
                  <div class="row">
                      <div class="col">
                          <button type="button" class="btn btn-danger" @click.prevent="removeSignImage">Rimuovi firma</button>
                      </div>
                      <div class="col text-center">
                          <button type="button" class="btn btn-secondary" @click.prevent="getSignImage">Modifica firma</button>
                      </div>
                      <div class="col text-right">
                          <button type="button" class="btn btn-primary" @click.prevent="signDocument">Firma il documento</button>
                      </div>
                  </div>
              </div>
              <div v-else class="row">
                  <div class="col">
                      <button type="button" class="btn btn-primary" @click.prevent="getSignImage">Acquisisci firma</button>
                  </div>
              </div>
          </template>
      </div>
      <div class="page-step" v-else-if="activeStep === 7">
          <h1>Pratica completata</h1>

          <template v-if="blockchainId">
              <strong>Blockchain Id</strong>: {{ blockchainId }}
              <div v-if="qrcodeSvg" v-html="qrcodeSvg"></div>
          </template>

          <button type="button" class="btn btn-primary" @click.prevent="reset">Chiudi pratica</button>
      </div>
    </template>
  </div>
</template>

<script>

import GetSignCard from '@/components/GetSignCard';
import LoginForm from '@/components/LoginForm';
import TakeRTCImage from '@/components/TakeRTCImage';
import $config from '@/services/config';
import qrcode from 'pure-svg-code/qrcode';

export default {
  name: 'app',
  components: {
    GetSignCard,
    LoginForm,
    TakeRTCImage,
    Loader: () => import('@/components/Loader'),
      SelectDocumentTypeForm: () => import('@/components/SelectDocumentTypeForm'),
  },
  data() {
    return {
        loading: true,

        documents: $config.get('documents'),

        logged: null,
        activeStep: 1,
        documentType: null,
        signImage: null,
        elaborateImageResult: null,
        getImageSignWidgetOpened: false,
        documentFields: {
            beneficiario: true,
        },
        documentFieldsHints: {},
        frontImage: null,
        rearImage: null,

        idPratica: null,
        scontrino: {
            data: null,
            importo: null,
            imponibile: null,
            iva: null,
            id: null,
        },
        textToSign: null,
        checkStatus: null,
        checks: [],
        finalStatus: null,
        blockchainId: null,
        qrcodeSvg: null,
    };
  },
  methods: {
    loginSuccess(user) {
      this.logged = user;
    },
    doLogout() {
      this.$oauth2.logout().then(() => {
        this.reset();
        this.logged = false;
      });
    },
    reset() {
      this.activeStep = 1;
      this.documentType = null;
      this.elaborateImageResult = null;
      this.getImageSignWidgetOpened = false;
      this.signImage = null;
      this.documentFields = {};
      this.documentFieldsHints = {};
      this.frontImage = null;
      this.rearImage  = null;

      this.scontrino = {
        data: null,
        importo: null,
        imponibile: null,
        iva: null,
        id: null,
      };
      this.idPratica = null;
      this.textToSign = null;
      this.checkStatus = null;
      this.checks = [];
      this.finalStatus = null;
      this.blockchainId = null;
      this.qrcodeSvg = null;
    },

    startWizard() {
      this.activeStep = 2;
      //this.documentType = this.documents.find(d => d.id === 5);
    },
    sendScontrino() {
      this.$api
          .createPratica(this.scontrino)
          .then(res => this.idPratica = res.data.id)
          .then(() => this.activeStep = 3)
      ;
    },
      selectDocumentType(documentType) {
          this.documentType = documentType;
          this.activeStep = 4;
      },
    elaborateImage() {
      this.activeStep = 5;
      this.elaborateImageResult = null;
      this.documentFieldsHints = {};

      this.$api.ocr(this.idPratica, (this.documentType || {}).id || null, this.frontImage)
          .then(res => {
            this.elaborateImageResult = true;
            this.documentFields = res.data.fields || {};
            this.documentFields.beneficiario = true;
            this.documentFieldsHints = res.data.hints;
          })
          .catch(() => this.elaborateImageResult = false)
      ;
    },
    retryElaborateImage() {
      this.activeStep = 4;
      this.elaborateImageResult = null;
      this.frontImage = null;
      this.rearImage = null;
      this.signImage = null;
    },
    getSignImage() {
      this.getImageSignWidgetOpened = true;
    },
    closeSignImage() {
      this.getImageSignWidgetOpened = false;
    },
    saveSignImage(image) {
      this.signImage = image;
      this.closeSignImage();
    },
    removeSignImage() {
      this.signImage = null;
    },
    setFrontImage(image) {
      this.frontImage = image;
    },
    removeFrontImage() {
      this.frontImage = null;
    },

    checkData() {
      this.$api
          .check(this.idPratica, this.documentFields)
          .then(res => {
            this.textToSign = res.data.text;
            this.checkStatus = res.data.status;
            this.checks = res.data.checks;
            this.activeStep = 6;
          })
      ;
    },
    signDocument() {
      this.$api
          .sign(this.idPratica, this.signImage)
          .then(res => {
            this.finalStatus = res.data.status;
            this.blockchainId = res.data.blockchain_id;

            if (this.blockchainId) {
                this.qrcodeSvg = qrcode({
                    content: this.blockchainId,
                    padding: 4,
                    width: 200,
                    height: 200,
                    color: "#000000",
                    background: "#ffffff",
                    ecl: "M",
                });
            }
            this.activeStep = 7;
          })
      ;
    },
      resetHint(fieldName) {
        if (this.documentFieldsHints[fieldName] !== undefined) {
            this.documentFieldsHints[fieldName] = undefined;
        }
      },
  },
  async created() {
    this.$oauth2
        .getMe()
        .then(me => {
          this.logged = me;

          /*
            if (me) {
              this.elaborateImageResult = true;
              this.activeStep = 5;
              this.checkStatus = 'ok';
              this.checks = {
                  'genio': 'ok',
                  'scadenza': 'ok',
                  'record': 'ok,'
              };
            }
          */
            /*
          this.documentType = this.documents.find(d => d.id === 5);
          this.activeStep = 3;
          */

        })
        .finally(() => this.loading = false)
    ;
  },
};

</script>
